(function () {
    angular.module('components.externalForm', ['utility'])
        .directive('externalForm', customForm);

    customForm.$inject = ['externalFormService'];
    function customForm(externalFormService) {
        var directive = {
            scope: {
                id: '@',
                datatypeId: '@',
                usePlaceholder: '=?',
                withBorder: '@',
                hideTitle: '@'
            },
            restrict: 'E',
            templateUrl: '/app_plugins/externalforms/components/externalForm/externalForm.html',
            link: link
        };
        return directive;
        function link(scope, element, attrs) {
            externalFormService.getForm(scope.id, scope.datatypeId)
                .then(function (response) {
                    scope.form = response.data;
                })
                .catch(function (data) {
                    scope.error = "An error occurred while loading the form.";
                });
        }
    }
})();